import { render, staticRenderFns } from "./GroupingIcon.vue?vue&type=template&id=151f8444"
import script from "./GroupingIcon.vue?vue&type=script&lang=js"
export * from "./GroupingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports